import  { useEffect, useState } from 'react'
import {Swiper,SwiperSlide} from 'swiper/react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../api/api';
import { FaCheck, FaHeart, FaShoppingCart, FaSpinner } from "react-icons/fa";
import { toast } from 'react-toastify';
import { IoIosArrowBack } from 'react-icons/io';
import parse from 'html-react-parser'
import { useTranslation } from 'react-i18next';
import { motion } from "framer-motion";
import { useProfileStore } from '../../store/useUserStore';
import { format12HourTime, formatDay } from '../../helpers/helper';
import { Pagination } from 'swiper/modules';

type Props = {}

interface Month {
    id: string;
    name: string;
    date: Date;
    disabled?: boolean;
}

const CourseEdit = (props: Props) => {
    const navigate = useNavigate()
    let { id } = useParams()
    const [course, setCourse] = useState<any>({
        images: [],
        name: "",
        description: "",
        course_type: 1,
        price: 0,
        branches: [],
        puchased_date: []
    })
    const { t } = useTranslation()
    const [cartOptionOpen, setCartOptionOpen] = useState(false)
    const { students, cartEdit, setLoading } = useProfileStore()
    const [ courseEditSelectedStudentId, setCourseEditSelectedStudentId] = useState<any>() // student_id

    const [selectedPricingPackage, setSelectedPricingPackage] = useState<any>(null)
    const [selectedClassroom, setSelectedClassroom] = useState<string | null>(null)
    const [selectedDay, setSelectedDay] = useState<string | null>(null)

    useEffect(() => {
        // console.log("courseEdit", cartEdit)
        if (cartEdit) {
            setCourseEditSelectedStudentId(cartEdit.student_id)
            getCourseByAcademy()
        } else {
            navigate("/cart")
        }
    }, [])

    useEffect(() => {
        if (course.id) {
            setData(cartEdit.course_slot_id)
        }
    }, [course])


    function getCourseByAcademy() {
        setLoading(true)
        api.get(`${process.env.REACT_APP_API_BASE_URL}/course/branch/${id}?start_from=${getSixMonthsBefore()}`).then( res => {
            setLoading(false)
            // console.log("res courseview", res.data.data)
            setCourse(res.data.data)
        }).catch( err => {
            setLoading(false)
            console.log("err", err)
        })
    }

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [selectedMonths, setSelectedMonths] = useState<Month[]>([]);

    function handleUpdateCart() {
        if (!selectedClassroom || !selectedDay) {
            return toast.warn(t('course_view.please_select_classroom_day_timeslot'))
        }

        let studentIds: number[] = []
       
        // from school
        if (!courseEditSelectedStudentId) return toast.warn(t('course_view.please_select_student'))
        studentIds = [courseEditSelectedStudentId]

        // Payment Term validation
        if (!selectedPricingPackage || (course.pricing_method.name === "Month" && selectedMonths.length !== selectedPricingPackage.count)) {
            return toast.warn(t('course_view.please_select_valid_payment_month'))
        }

        // Check if selectedMonths length is a valid multiple of course.period
        if (course.pricing_method && course.pricing_method.name === "Month") {
            if (selectedMonths.length === 0) return toast.warn(t('course_view.please_select_period'))
        }

        // Convert selectedMonths into the desired format
        const formattedMonths = selectedMonths.map((month: Month) => {
            const [monthName, year] = month.name.split(" ")
            const date = new Date(`${monthName} 1, ${year}`)
            return date.toLocaleDateString("en-US", { month: "2-digit", year: "numeric" })
        })

        // Get the selected classroom
        const classroom = course.time_slots.find((slot: any) => slot.course_slot_id === parseInt(selectedClassroom!))
        if (!classroom) return toast.warn(t('course_view.please_select_classroom_day_timeslot'));
       
        const timeSlotId = course.time_slots.flatMap(slot => slot.schedules).find(schedule => schedule.course_schedule_id == selectedDay)?.class_timeslots[0]?.time_slot_id;

        let payload = {
            "course_slot_id": selectedClassroom,
            "course_schedule_id": selectedDay,
            "time_slot_id": timeSlotId,
            "package_id": selectedPricingPackage.id,
        }


        // pricing_method == Month only have selected Month to choose
        if (course.pricing_method && course.pricing_method.name === "Month") {
            payload["selected_date"] = formattedMonths
        }

        // console.log("payload", payload)

        setLoading(true)
        api.put(`${process.env.PUBLIC_URL}/cart/edit/${cartEdit.id}`, payload).then(res => {
            setLoading(false)
            toast.success(t("course_view.updated_cart"))
            navigate("/cart")
            console.log("res", res)
        }).catch(err =>{
            setLoading(false)
            if (err.response && err.response.data && err.response.data.errors && err.response.data.errors.message.length > 0) {
                for (let msg in err.response.data.errors.message) {
                    toast.error(err.response.data.errors.message[msg])
                }
            } else {
                toast.error(t("server_error"))
            }
        }).finally(()=>{
            setCartOptionOpen(false)
        })
    }

    useEffect(() => {
        // Attach event listener to close dropdown on outside click
        document.addEventListener("click", handleClickOutside)
        return () => {
            document.removeEventListener("click", handleClickOutside)
        };
    }, [])

    const handleClickOutside = (event:any) => {
        // Close the dropdown if clicked outside
        if (!event.target.closest(".dropdown-container")) {
            setIsOpen(false)
        }
    }

    const toggleDropdown = (): void => {
        setIsOpen(!isOpen);
    };

    const getMonths = (): Month[] => {
        const months: Month[] = []
        const startDate = new Date()
        startDate.setDate(1) // Start from the first day of the current month
        startDate.setMonth(startDate.getMonth() - 6) // Move 6 months back

        // English month names
        const monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]

        for (let i = 0; i < 24; i++) { // Total 24 months (6 past + current + 17 future)
            const month = new Date(startDate)
            month.setMonth(startDate.getMonth() + i)

            const year = month.getFullYear()
            const monthNumber = String(month.getMonth() + 1).padStart(2, "0")
            const monthIndex = month.getMonth()

            months.push({
                id: `${year}-${monthNumber}`,
                name: `${monthNames[monthIndex]} ${year}`,
                date: month,
                disabled: (course.purchased_date && course.purchased_date.includes(`${year}-${monthNumber}`)) ? true : false
            })
        }
    
        return months
    }

    const months: Month[] = getMonths()

    const handleSelectMonth = (selectedMonth: Month): void => {
        // if (selectedMonth.disabled) return;
        const index = months.findIndex((m) => m.id === selectedMonth.id)
    
        const foundItem = selectedMonths.find(item => item.id === months[index].id);
        if (foundItem) {
            // remove
            const updatedSelectedMonths = selectedMonths.filter(item => item.id != selectedMonth.id)
            setSelectedMonths(updatedSelectedMonths)
        } else {
            // add
            const newSelectedMonths: Month[] = [];
            const month = months[index]
            newSelectedMonths.push({
                id: month.id,
                name: month.name,
                date: month.date,
                disabled: false, // Adjust if needed
            })

            setSelectedMonths([...selectedMonths, ...newSelectedMonths])
        }
    }

    const isChecked = (month: Month): boolean => {
        return selectedMonths.some((m) => m.id === month.id)
    }

    const getSelectedRangeLabel = (): string => {
        if (selectedMonths.length === 0) return "Select a Month"
        // const startMonth = selectedMonths[0].name
        // const endMonth = selectedMonths[selectedMonths.length - 1].name
        // const period = course.period || 1
        // if (period === 1) {
        //     return `${startMonth}`
        // }
        // return `${startMonth} - ${endMonth}`
        const items = selectedMonths
        
        items.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
        
        let returnString = ""
        for (let selected of items) {
            returnString += selected.name + ", "
        }

        return returnString
    }

    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    const getShortenedDescription = (html:any) => {
        if (html == "" || html == null) return ""
        
        const tempElement = document.createElement('div');
        tempElement.innerHTML = html;
      
        // Replace <p> and <br> with newline characters to count lines
        const textWithLineBreaks = tempElement.innerHTML
          .replace(/<\/p>|<br\s*\/?>/gi, '\n') // Add line breaks
          .replace(/<[^>]+>/g, '') // Remove other HTML tags
          .trim();
      
        // Split by lines and take only first 8 lines
        const lines = textWithLineBreaks.split('\n');
        const maxLines = 8;
        
        if (lines.length <= maxLines) {
            // If content has 8 lines or less, return the original HTML
            return parse(html);
        }
        
        // Take first 8 lines and add ellipsis
        const shortenedLines = lines.slice(0, maxLines);
        const shortenedText = shortenedLines.join('\n') + '...';
      
        // Replace newlines with <br> before parsing
        return parse(shortenedText.replace(/\n/g, '<br/>'));
    }
      

    const navigateBack = () => {
        navigate('/cart', { replace: true }); // Navigate to the home page if no history exists
    }

    function getSixMonthsBefore(): string {
        // For matching with purchased_date / waive course month
        const now = new Date()
        now.setMonth(now.getMonth() - 6)
      
        const year = now.getFullYear()
        const month = String(now.getMonth() + 1).padStart(2, "0") // Ensure two-digit month format
        // YYYY-MM
        return `${year}-${month}`
    }

    function getBasePrice(): string {
        if (course.pricing_packages && course.pricing_packages.length > 0) {
            return "RM "+course.pricing_packages[0].fee
        }
        return "-"
    }

    function getCalculatedPrice(): string {
        return selectedPricingPackage ? selectedPricingPackage.fee : "-"
    }


    const [scheduleOptions, setScheduleOptions] = useState< { course_schedule_id: number; label: string }[] >([])

    // Handle classroom selection
    
    const handleClassroomChange = (classroomId: string) => {
        setSelectedClassroom(classroomId);
        setSelectedDay(null)

        const classroom = course.time_slots.find(
            (slot: any) => slot.course_slot_id === parseInt(classroomId)
        );

        if (!classroom) return setScheduleOptions([]);

        const formatted = classroom.schedules.map((schedule: any) => {
            const timeslotLabels = schedule.class_timeslots.map((ts: any) => {
                const start = format12HourTime(ts.start_time);
                const end = format12HourTime(ts.end_time);
                const day = formatDay(ts.day);
                return `${start} – ${end} ${day}`;
            })

            // Format combined string
            const label = timeslotLabels.length === 1
                ? timeslotLabels[0]
                : timeslotLabels.slice(0, -1).join(", ") + " & " + timeslotLabels.slice(-1);

            return {
                course_schedule_id: schedule.course_schedule_id,
                label,
            }
        })

        setScheduleOptions(formatted)
    }

    const handleDayChange = (course_schedule_id:string) => {
        setSelectedDay(course_schedule_id)
    }

    function setData(course_slot_id: string) {
        setSelectedClassroom(course_slot_id)
        handleClassroomChange(course_slot_id)

        // Get the selected classroom
        const classroom = course.time_slots.find((slot: any) => slot.course_slot_id == parseInt(course_slot_id))
        if (classroom) {
            for (const schedule of classroom.schedules) {
                if (schedule.course_schedule_id == cartEdit.course_schedule_id) {
                    setSelectedDay(schedule.course_schedule_id)
                }
                // for (const slot of schedule.class_timeslots) {
                //     if (slot.time_slot_id === cartEdit.time_slot_id) {
                //         handleDayChange(slot.day, course_slot_id)
                //         // handleTimeslotChange(cartEdit.time_slot_id)
                //     }
                // }
            }

            setSelectedPricingPackage(cartEdit.selected_package)

            if (cartEdit.pricing_method === "Month") {
                const dateStrings = cartEdit.selected_date.split(",").map(str => str.trim())
                const newSelectedMonths: Month[] = []

                dateStrings.forEach(monthName => {
                    // Fix for iOS date parsing
                    const [month, year] = monthName.split(" ")
                    const monthIndex = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"].indexOf(month)
                    const date = new Date(parseInt(year), monthIndex)
                    const id = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`

                    const existing = months.find(m => m.id === id) // only add if in available list
                    if (existing) {
                        newSelectedMonths.push({
                            id,
                            date,
                            name: monthName,
                            disabled: false,
                        })
                    }
                })

                setSelectedMonths(newSelectedMonths)
            }
        }
    }
      
    return (
        <>
        <div className="pb-20 px-2">
            <div className='mb-3 grid grid-cols-6'>
                <div className='self-center'><IoIosArrowBack size={24} color='#000' onClick={()=>navigateBack()}/></div>
                <div className='text-center col-span-4 text-lg font-medium'>{course.course_name}</div>
                <div></div>
            </div>
            <div className="mb-4">
                <Swiper
                    pagination={{
                        dynamicBullets: true,
                    }}
                    modules={[Pagination]}
                    className="h-96">
                    {course.images.map((img: string, index: number) => (
                    <SwiperSlide key={index}>
                        <div className="flex justify-center items-center w-full bg-white h-[calc(100%-30px)]">
                            <img src={img} alt={`Slide ${index}`} className="object-cover h-full"/>
                        </div>
                    </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            <div className="pt-4 pb-2">
                <div className="mb-4">
                    <div className="grid grid-cols-6 gap-1">
                        <div className="col-span-4">
                            <div className="text-lg font-medium">{course.course_name}</div>
                            <div className="text-base mt-1 font-normal">{course.branch_name || "-"}</div>
                        </div>
                        <div className="col-span-2 text-right text-lg font-medium">{getBasePrice()}</div>
                    </div>
                </div>

                
            </div>

            <div className="pb-1 pt-2 border-gray-300 border-t-2">
                {/* Tab-like Navigation */}
                <div className="flex mb-4 justify-around">
                    <button className="px-4 py-2 text-lg font-medium border-b-2 border-theme" >
                    {t('course_view.detail')}
                    </button>
                </div>

                <div id="detail-section" className="mb-4">
                    <div className="mb-4">
                        <div className="text-sm">
                            {isExpanded ? parse(course.description) : getShortenedDescription(course.description)}
                        </div>
                        <button className="text-theme hover:text-theme focus:outline-none mt-2 text-sm underline" onClick={toggleExpanded} >
                            {isExpanded ? t("course_view.view_less") : t("course_view.view_more")}
                        </button>
                    </div>

                    <div className="mb-2 text-sm space-y-1">
                        <div>
                            <span className="text-base font-medium"> {t("course_view.website")}:{" "} </span>
                            {course.website_link === "-" || !course.website_link ? (
                                "-"
                            ) : (
                                <a href={course.website_link} target="_blank" rel="noopener noreferrer" className="underline hover:text-theme">{course.website_link}</a>
                            )}
                        </div>
                        <div>
                            <span className="text-base font-medium"> {t("course_view.youtube")}:{" "} </span>
                            {course.youtube_link === "-" || !course.youtube_link ? (
                                "-"
                            ) : (
                                <a href={course.youtube_link} target="_blank" rel="noopener noreferrer" className="underline hover:text-theme">{course.youtube_link}</a>
                            )}
                        </div>
                    </div>
                </div>

            </div>

            <div className="flex justify-center">
                <button onClick={() => {
                    setCartOptionOpen(true)
                }} className="bg-theme w-5/6 flex gap-3 text-white justify-center text-center mb-3 h-12 py-2 px-4 font-normal text-base items-center rounded-full cursor-pointer hover:bg-gray-400" >
                    <FaShoppingCart size={18} />
                    {t('course_view.update_cart')}
                </button>
            </div>

            {cartOptionOpen && (
                <div className="fixed inset-0 z-10 bg-black bg-opacity-50 flex justify-center items-end" onClick={() => setCartOptionOpen(false)} >
                    <motion.div
                        initial={{ y: "100%" }}
                        animate={{ y: 0 }}
                        exit={{ y: "100%" }}
                        transition={{ stiffness: 100 }}
                        className="w-full max-w-[648px] bg-white shadow-2xl rounded-t-3xl px-4 pt-4 pb-20 max-h-[90vh] overflow-y-auto"
                        onClick={(e) => e.stopPropagation()}
                    >
                
                    <div className="grid grid-cols-6 gap-1 pb-3 mb-3 border-b-2 border-gray-300">
                        <div className="col-span-4">
                        <div className='text-lg font-medium'>{course.course_name}</div>
                        <div className='text-md mt-1 font-normal'>{course.branch_name || "-"}</div>
                        </div>
                        <div className="text-lg font-medium col-span-2 text-end">RM {getCalculatedPrice()}</div>
                    </div>

                    {/* Classroom Selection */}
                    <div className="mb-1 text-base font-medium">
                        ✏️ {t('course_view.classroom')} <span className="italic text-gray-400 font-light">{t('course_view.choose_1_only')}</span>
                    </div>
                    <div className="grid grid-cols-1 gap-2 mb-4">
                        {course.time_slots &&
                            course.time_slots.map((classroom: any) => (
                                <div key={classroom.course_slot_id}
                                    className={`flex items-center gap-2 px-2 py-2 rounded-lg w-full border ${
                                        selectedClassroom === classroom.course_slot_id ? "bg-theme text-white" : "bg-gray-100 text-black"
                                    } transition duration-300`}
                                    onClick={() => handleClassroomChange(classroom.course_slot_id)}
                                >
                                    {selectedClassroom === classroom.course_slot_id ? (
                                        <div className="w-5 h-5 border-2 border-white rounded-full flex items-center justify-center">
                                            <div className="w-2.5 h-2.5 bg-white rounded-full"></div>
                                        </div>
                                    ) : (
                                        <div className="w-5 h-5 border-2 border-black rounded-full flex items-center justify-center">
                                            <div className="w-2.5 h-2.5 rounded-full"></div>
                                        </div>
                                    )}
                                    <div>{classroom.name}</div>
                                </div>
                            ))}
                    </div>

                    {/* Day Selection */}
                    <div className="mb-4">
                        <div className="mb-1 text-base font-medium">
                            📅 {t('course_view.class_day')} <span className="italic text-gray-400 font-light">{t('course_view.choose_1_only')}</span>
                        </div>
                        <select
                            className="text-lg font-light rounded-md px-2 py-1 bg-white border border-gray-300 flex items-center w-full truncate"
                            value={selectedDay || ""}
                            onChange={(e) => handleDayChange(e.target.value)}
                            disabled={!selectedClassroom}
                        >
                            <option value="" disabled>{t('course_view.select_day')}</option>
                            {scheduleOptions.map((opt) => (
                                <option key={opt.course_schedule_id} value={opt.course_schedule_id}>
                                    {opt.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    {course.pricing_method && course.pricing_method.name === "Month" && (
                    <>
                    <div className="pt-2 border-gray-300 border-t-2 mb-3">
                        <div className='mb-1 text-base font-medium'>{t('course_view.payment_term')} <span className='italic text-gray-400 font-light'>* {t('course_view.choose_1_only')}</span></div>
                        <div className="grid grid-cols-2 gap-2 mt-2">
                            {course.pricing_packages && course.pricing_packages.filter((pricingPackage: any) => selectedPricingPackage?.id === pricingPackage.id).map((pricingPackage: any) => (
                                <div key={pricingPackage.id} className="flex items-center gap-2 px-2 py-2 rounded-lg w-full border bg-theme text-white transition duration-300" onClick={() => setSelectedPricingPackage(pricingPackage)} >
                                    <div className="w-5 h-5 border-2 border-white rounded-full flex items-center justify-center">
                                        <div className="w-2.5 h-2.5 bg-white rounded-full"></div>
                                    </div>
                                    <div className="truncate">
                                        {pricingPackage.count} {t('course_view.month')} RM {pricingPackage.fee}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    
                    <div className="pb-2 pt-2 border-t-2 border-gray-300">
                        <div className="mb-1 text-base font-medium">{t('course_view.paying_for')}</div>
                        <div className="mt-2 border border-gray-300 rounded-md bg-white">
                            <button className="text-lg font-light px-2 py-1 w-full flex items-center truncate" onClick={toggleDropdown} >
                                <span>{getSelectedRangeLabel()}</span>
                            </button>
                            {isOpen && (
                            <div className="mt-1 border-t border-gray-200 w-full max-h-52 overflow-y-auto z-10" >
                                {months.map((month) => (
                                <div key={month.id} className={`flex items-center px-4 py-1 ${month.disabled ? "opacity-50 cursor-not-allowed line-through" : "hover:bg-gray-100 cursor-pointer"}`} onClick={() => {
                                        if (!month.disabled) {
                                            handleSelectMonth(month)
                                        }
                                }}>
                                    <input type="checkbox" className="mr-2" checked={isChecked(month)} readOnly disabled={month.disabled} />
                                    <span className="text-lg">{month.name} {month.disabled && `(${t('course_view.waived')})`}</span>
                                </div>
                                ))}
                            </div>
                            )}
                        </div>
                    </div>
                    </>
                    )}

                    {course.pricing_method && (course.pricing_method.name === "Attandance" || course.pricing_method.name === "Attandance-No replace") && (
                    <>
                    <div className="pb-2 pt-2 border-gray-300 border-t-2 mb-2">
                        <div className='mb-1 text-base font-medium'>{t('course_view.payment_term')} <span className='italic text-gray-400 font-light'>* {t('course_view.choose_1_only')}</span></div>
                        <div className="grid grid-cols-2 gap-2 mt-2">
                            {course.pricing_packages && course.pricing_packages.map((pricingPackage:any) => (
                            <div key={pricingPackage.id} className={`flex items-center gap-2 px-2 py-2 rounded-lg w-full border ${selectedPricingPackage?.id === pricingPackage.id ? " bg-theme  text-white " : "bg-gray-100 text-black"} transition duration-300`} onClick={() => setSelectedPricingPackage(pricingPackage)}>
                                {selectedPricingPackage?.id == pricingPackage.id ? (
                                    <div className="w-5 h-5 border-2 border-white rounded-full flex items-center justify-center">
                                        <div className="w-2.5 h-2.5 bg-white rounded-full"></div>
                                    </div>
                                ) : (
                                    <div className="w-5 h-5 border-2 border-black rounded-full flex items-center justify-center">
                                        <div className="w-2.5 h-2.5 rounded-full"></div>
                                    </div>
                                )}
                                <div className="truncate ">{pricingPackage.count} attd RM {pricingPackage.fee}</div>
                            </div>
                            ))}
                        </div>
                    </div>
                    </>
                    )}


                    <div className="pb-2 pt-2 border-gray-300 border-t-2 ">
                        <div className='mb-1 text-base font-medium'>{t('course_view.choose_student')}</div>

                        <div className="grid grid-cols-2 gap-2 mt-2">
                            {students && students.map((student:any) => (
                            <div key={student.id} className={`flex items-center gap-2 px-2 py-2 rounded-lg w-full border ${courseEditSelectedStudentId == student.id ? " bg-theme  text-white " : "bg-gray-100 text-black"} transition duration-300`}>
                                {courseEditSelectedStudentId == student.id ? (
                                    <>
                                    <div className="flex-shrink-0 w-5 h-5 border-2 border-white rounded-full flex items-center justify-center">
                                        <div className="w-2.5 h-2.5 bg-white rounded-full"></div>
                                    </div>
                                    <div className="pl-1 truncate">{student.name}</div>
                                    </>
                                ) : (
                                    <>
                                    <div className="flex-shrink-0 w-5 h-5 border-2 border-gray-400 rounded-full flex items-center justify-center">
                                        <div className="w-2.5 h-2.5 rounded-full"></div>
                                    </div>
                                    <div className="pl-1 truncate text-gray-400">{student.name}</div>
                                    </>
                                )}
                            </div>
                            ))}
                        </div>
                    </div>

                    <button onClick={() => handleUpdateCart()} className="bg-theme w-full flex gap-3 text-white justify-center text-center h-12 py-2 px-4 font-normal text-base items-center rounded-full cursor-pointer hover:bg-gray-400l mt-3" >
                        <FaShoppingCart size={18} />
                        {t('course_view.update_cart')}
                    </button>
                    </motion.div>
                </div>
            )}

        </div>
    </>
    )
}

export default CourseEdit